import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import TranslationService from "../../../../Services/Translation/TranslationService";
import AutoTranslate from "../../../../Components/AutoTranslate";
import { Form } from "react-bootstrap";

const Step3 = ({ stepLabels = [], onSubmit = () => {}, onNext = () => {}, onPrev = () => {}, formData = {}, setFormData = () => {} }) => {
  const location = useLocation();
  const language = useSelector((state) => state.localStorage.language);
  const [safeAgreement, setSafeAgreement] = useState(formData.safeAgreement);
  const [wording, setWording] = useState({
    placeholder: "위 내용을 꼼꼼히 확인했으며 동의합니다.",
    disabledPlaceholder: "위 내용을 끝까지 읽고 스크롤한 후 동의할 수 있습니다.",
  });
  const [canAgree, setCanAgree] = useState(false);
  const [hasScrolledToBottom, setHasScrolledToBottom] = useState(false);

  useEffect(() => {
    Init();
  }, []);

  useEffect(() => {
    if (!Array.isArray(safeAgreement) || safeAgreement.length === 0) {
      setCanAgree(true);
      setHasScrolledToBottom(true);
    }
  }, [safeAgreement]);

  const handleScroll = (e) => {
    const { scrollTop, scrollHeight, clientHeight } = e.target;
    if (scrollTop + clientHeight >= scrollHeight - 10) {
      setHasScrolledToBottom(true);
      setCanAgree(true);
    }
  };

  const Init = async () => {
    const _placeholder = await TranslationService.translateText(wording.placeholder, language.lang);
    const _disabledPlaceholder = await TranslationService.translateText(wording.disabledPlaceholder, language.lang);
    setWording({ ...wording, placeholder: _placeholder, disabledPlaceholder: _disabledPlaceholder });
  };

  return (
    <div className='flex-column-center-center gap-5 w-100'>
      <div className='step-form-container'>
        <div>
          <div
            className='agreement-container'
            style={{
              maxHeight: "400px",
              overflowY: "auto",
              border: "1px solid #ddd",
              borderRadius: "8px",
              padding: "20px",
            }}
            onScroll={handleScroll}
          >
            <h3 className='agreement-title'>
              <AutoTranslate targetLanguage={language.lang}>{stepLabels[3]}</AutoTranslate>
            </h3>
            {Array.isArray(safeAgreement) &&
              safeAgreement.map((item, index) => {
                return (
                  <div key={index} className='agreement-item'>
                    <p className='agreement-text'>
                      <AutoTranslate targetLanguage={language.lang}>{item.label}</AutoTranslate>
                    </p>
                  </div>
                );
              })}
            <div className='flex-column-center w-100'>
              <p>
                <AutoTranslate targetLanguage={language.lang}>본 근로자는 당 현장에서 근무하는 기간동안 산업안전보건법 제25조 근로자 준수사항에 의거한 안전사항과</AutoTranslate>
              </p>
              <p>
                <AutoTranslate targetLanguage={language.lang}>{`${location.state.company?.companyName} 안전규칙을 성실하고 철저하게 준수할 것이며 위 각호의 사항 중 어느 하나라도`}</AutoTranslate>
              </p>
              <p>
                <AutoTranslate targetLanguage={language.lang}>미이행 시 발생하는 모든 손실에 대한 책임(민,형사상)은 본인에게 귀속됨을 동의합니다.</AutoTranslate>
              </p>
            </div>
          </div>
        </div>
        <div className='flex-end-center w-100 mt-3 pe-3'>
          <Form onSubmit={(e) => e.preventDefault()}>
            <Form.Group className='w-100'>
              <Form.Check
                id='safetyAgreement'
                className='custom-checkbox'
                type='checkbox'
                label={hasScrolledToBottom ? wording.placeholder : wording.disabledPlaceholder}
                checked={formData.pledgeConfirmed}
                onChange={(e) => setFormData((prev) => ({ ...prev, pledgeConfirmed: e.target.checked }))}
                disabled={!canAgree}
              />
            </Form.Group>
          </Form>
        </div>
        <div className='step-button-group'>
          <button className='step-button step-button-secondary' onClick={onPrev}>
            <AutoTranslate targetLanguage={language.lang}>이전</AutoTranslate>
          </button>
          <button className={`step-button step-button-success ${!formData.pledgeConfirmed || !canAgree ? "disabled" : ""}`} onClick={onSubmit} disabled={!formData.pledgeConfirmed || !canAgree}>
            <AutoTranslate targetLanguage={language.lang}>제출하기</AutoTranslate>
          </button>
          {/* <button
            className={`step-button step-button-primary ${!formData.pledgeConfirmed ? "disabled" : ""}`}
            onClick={() => {
              if (formData.pledgeConfirmed) {
                onNext();
              }
            }}
            disabled={!formData.pledgeConfirmed}
          >
            <AutoTranslate targetLanguage={language.lang}>다음</AutoTranslate>
          </button> */}
        </div>
      </div>
    </div>
  );
};

export default Step3;
